/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerCreateMutationRequest, ContractDocumentsControllerCreateMutationResponse, ContractDocumentsControllerCreate400, ContractDocumentsControllerCreate401, ContractDocumentsControllerCreate403 } from "../../models/contractDocumentsController/ContractDocumentsControllerCreate";

function getContractDocumentsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/contract-documents` as const }  
  return res
}

/**
 * @summary Set a project's contract document, importing from ProjectSight or pointing at an existing file
 * {@link /api/v1/contract-documents}
 */
export async function contractDocumentsControllerCreate(data?: ContractDocumentsControllerCreateMutationRequest, config: Partial<RequestConfig<ContractDocumentsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContractDocumentsControllerCreateMutationResponse, ResponseErrorConfig<ContractDocumentsControllerCreate400 | ContractDocumentsControllerCreate401 | ContractDocumentsControllerCreate403>, ContractDocumentsControllerCreateMutationRequest>({ method : "POST", url : getContractDocumentsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}